import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread(_objectSpread({}, utils), platform);